<style></style>
<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="main-card mb-3 card">
        <div style="margin: 40px">
          <table class="board_table">
            <tr>
              <th>제목</th>
              <td colspan="5">{{ article.title }}</td>
            </tr>
            <tr>
              <th>작성자</th>
              <td>{{ article.adminName }}</td>
              <th>작성일</th>
              <td>{{ article.created_at }}</td>
              <th>조회수</th>
              <td>{{ article.readCnt }}</td>
            </tr>
            <tr v-if="this.$route.params.board == '2022_summer'">
              <th v-if="article.addi_data1">시작일</th>
              <td v-if="article.addi_data1">{{ article.addi_data1 }}</td>
              <th v-if="article.addi_data2">종료일</th>
              <td v-if="article.addi_data2">{{ article.addi_data2 }}</td>
              <th v-if="article.addi_data3">이미지 주소</th>
              <td v-if="article.addi_data3">{{ article.addi_data3 }}</td>
            </tr>
            <tr v-if="this.$route.params.board == 'announce'">
              <th v-if="article.addi_data1">메인홈페이지 표시여부</th>
              <td v-if="article.addi_data1">
                {{ article.addi_data1 == "1" ? "O" : "X" }}
              </td>
              <th v-if="article.addi_data2">학원홈페이지 표시여부</th>
              <td v-if="article.addi_data2">
                {{ article.addi_data2 == "1" ? "O" : "X" }}
              </td>
            </tr>
            <tr>
              <td
                colspan="6"
                style="text-align: left"
                v-html="article.content"
              ></td>
            </tr>
          </table>

          <div style="float: right">
            <router-link to="/events/learningreview"
              ><button class="btn btn-secondary">
                목&nbsp;&nbsp;록
              </button></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    article: {},
    eligible_to_modify: false,
  }),
  methods: {
    loadArticle() {
      axios
        .get("/articles_event/review/" + this.$route.params.article)
        .then((response) => {
          if (response.data.error) {
            alert("게시글을 불러올 수 없습니다.\n" + response.data.error);
          } else {
            this.article = response.data.result;
            if (response.data.eligible_to_modify) {
              this.eligible_to_modify = true;
            }
          }
        });
    },
    deleteArticle() {
      axios
        .delete("/articles_event/review/" + this.$route.params.article)
        .then((response) => {
          if (response.data.error) {
            alert("삭제 실패하였습니다.\n" + response.data.error);
          } else {
            $.notify(
              {
                // options
                message: "삭제되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.$router.push("/events/learningreview");
          }
        });
    },
  },
  mounted() {
    this.loadArticle();
  },
};
</script>
